import { render } from "./StateDashboard.vue?vue&type=template&id=19fbfe19&scoped=true"
import script from "./StateDashboard.vue?vue&type=script&lang=js"
export * from "./StateDashboard.vue?vue&type=script&lang=js"

import "./StateDashboard.vue?vue&type=style&index=0&id=19fbfe19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fbfe19"]])

export default __exports__